/**
 * Dynamically inserts a type key into every language node of an image object
 * @param {Object} imageObj - The nested language object (e.g., savedTemplate.image)
 * @param {String} keyVal - The value to assign to the 'type' key
 * @returns {Object} A clean, updated copy of the image object
 */
export function insertType(imageObj, keyVal) {
  if (!imageObj || typeof imageObj !== 'object') return imageObj;

  // 1. Create a deep clone to safely modify the structure
  const clonedImageObj = _.cloneDeep(imageObj);

  // 2. Loop through all language keys (zh-HK, zh-TW, en, zh-CN)
  Object.keys(clonedImageObj).forEach((lang) => {
    if (clonedImageObj[lang] && typeof clonedImageObj[lang] === 'object') {
      // 3. Inject the type property alongside cosKey and cosUrl
      clonedImageObj[lang].type = keyVal;
    }
  });

  return clonedImageObj;
}